import { useEffect, useRef, useState } from 'react';
import './ContactUs.css';
import Nav from './Nav';
import Footer from './Footer';
import ScaleFrame from './ScaleFrame';
import ContactForm from './ContactForm';
import plate from '../assets/cutouts/plate.png';
import linkedin from '../assets/logo/linkedin.png';

// Height of #sib-form (desktop, before the font-size bump) that the plate /
// LinkedIn positions in ContactUs.css were originally laid out around.
const FORM_BASE_HEIGHT = 817;

function ContactUs() {
  const [submitted, setSubmitted] = useState(false);
  const sectionRef = useRef(null);

  // The form's height depends on font size and viewport (rows stack on
  // mobile), so everything below it is pushed down by however much taller
  // it is than FORM_BASE_HEIGHT — the height the fixed positions in
  // ContactUs.css were laid out around. See --form-shift there.
  useEffect(() => {
    const section = sectionRef.current;
    const form = section?.querySelector('#sib-form');
    if (!form) return undefined;

    const update = () => {
      const shift = Math.max(0, form.offsetHeight - FORM_BASE_HEIGHT);
      section.style.setProperty('--form-shift', `${shift}px`);
    };
    const observer = new ResizeObserver(update);
    observer.observe(form);
    update();
    return () => observer.disconnect();
  }, []);

  return (
    <ScaleFrame>
      <section ref={sectionRef} className={'ContactUs' + (submitted ? ' ContactUs--submitted' : '')}>
        <Nav />

        <h1 className="ContactUs-heading">Contact Us</h1>
        <p className="ContactUs-subheading">We would love to hear from you!</p>


        <ContactForm onSuccess={() => setSubmitted(true)} />

        <svg className="ContactUs-linkedinArc" viewBox="0 0 900 220">
          <path id="linkedinArc" d= "M 120 270 Q 450 -130 780 270" fill="none" />
          <text>
            <textPath href="#linkedinArc" startOffset="50%" textAnchor="middle">
              Find us on LinkedIn
            </textPath>
          </text>
        </svg>

        <img className="ContactUs-plate" src={plate} alt="" />
        <a
          className="ContactUs-linkedinLink"
          href="https://www.linkedin.com/company/insane-vegan/"
          target="_blank"
          rel="noreferrer"
        >
          <img className="ContactUs-linkedinIcon" src={linkedin} alt="LinkedIn" />
        </a>

        <Footer />
      </section>
    </ScaleFrame>
  );
}

export default ContactUs;
